Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var require_syncHook = require('./syncHook.cjs');
//#region src/utils/hooks/asyncHook.ts
var AsyncHook = /*#__PURE__*/ function(_require_syncHook_SyncHook) {
    "use strict";
    _inherits._(AsyncHook, _require_syncHook_SyncHook);
    function AsyncHook() {
        _class_call_check._(this, AsyncHook);
        return _call_super._(this, AsyncHook, arguments);
    }
    _create_class._(AsyncHook, [
        {
            key: "emit",
            value: function emit() {
                for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
                    data[_key] = arguments[_key];
                }
                var result;
                var ls = Array.from(this.listeners);
                if (ls.length > 0) {
                    var i = 0;
                    var call = (prev)=>{
                        if (prev === false) return false;
                        else if (i < ls.length) return Promise.resolve(ls[i++].apply(null, data)).then(call);
                        else return prev;
                    };
                    result = call();
                }
                return Promise.resolve(result);
            }
        }
    ]);
    return AsyncHook;
}(require_syncHook.SyncHook);
//#endregion
exports.AsyncHook = AsyncHook; //# sourceMappingURL=asyncHook.cjs.map
